import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { RefreshRounded, ReportProblemRounded } from '@mui/icons-material';
import {
  Alert,
  AlertTitle,
  Button,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useNavigate } from 'react-router';

export interface RefreshDashboardModalProps {
  label?: 'Dashboard' | 'Saved Search' | 'Feed';
}

export const RefreshDashboardModal = ({
  label = 'Dashboard',
}: RefreshDashboardModalProps = {}) => {
  const navigate = useNavigate();

  return (
    <>
      <ModalHeader
        title={`${label} contains outdated information`}
        showCloseButton={false}
      />
      <DialogContent>
        <Alert
          severity="warning"
          icon={<ReportProblemRounded />}
          sx={{ alignItems: 'center' }}
        >
          <AlertTitle>
            This {label} contains changes that are not updated.
          </AlertTitle>
          To see the latest updates and make changes, please refresh the page.
        </Alert>
        <DialogActions sx={{ mt: 2, pr: 0 }}>
          <Button
            variant="contained"
            onClick={() => navigate(0)}
            startIcon={<RefreshRounded />}
          >
            Refresh Page
          </Button>
        </DialogActions>
      </DialogContent>
    </>
  );
};
